/* unplugin-vue-components disabled */import { render } from "./DownloadHang.vue?vue&type=template&id=c20dacf8"
import script from "./DownloadHang.vue?vue&type=script&lang=js"
export * from "./DownloadHang.vue?vue&type=script&lang=js"

import "./DownloadHang.vue?vue&type=style&index=0&id=c20dacf8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__